export default "__VITE_ASSET__B4Sd7s4d__"